module.exports = __webpack_public_path__ + "static/DY0-b769f92799f01537a17b219c9c88deae.jpg";